/**
 * @module 协议相关模块路由
 */
export default [
  // 360API对接兰州银行协议未及时生成中间页
  {
    path: '/protocol/lzbankcontract',
    name: 'protocol_lzbankcontract',
    meta: { title: '合同详情' },
    component: () => import('@/pages/protocol/borrow/lzbank-contract')
  },
  {
    path: '/protocol/queryaccredit',
    name: 'queryaccredit',
    meta: { title: '易借平台用户授权协议' },
    component: () => import('@/pages/protocol/app/queryaccredit')
  },
  // 借款合同模版（根据资方进行展示）
  {
    path: '/protocol/borrowservice',
    name: 'borrowservice',
    meta: { title: '' },
    component: () => import('@/pages/protocol/borrowservice')
  },
  // 《个人征信授权书》 《个人授权委托书CA证书》《个人信息使用授权书》
  {
    path: '/protocol/xs/personMultiple',
    name: 'xs_person_multiple',
    meta: { title: '' },
    component: () => import('@/pages/protocol/xs/personMultiple')
  },
  // 授信前协议(榕树及其他三方 三合一)
  {
    path: '/protocol/rongshu/creditAuth',
    name: 'rongshu_creditAuth',
    meta: { title: '个人征信及信息授权书' },
    component: () => import('@/pages/protocol/rongshu/creditAuth')
  },
  // 借款后协议(榕树及其他三方 四合一)
  {
    path: '/protocol/rongshu/loan',
    name: 'rongshu_loan',
    meta: { title: '借款合同' },
    component: () => import('@/pages/protocol/rongshu/loan')
  },
  // 申请借款(锡商协议)
  {
    path: '/rongshu/loanForce',
    name: 'rongshu_loanForce',
    meta: { title: '借款合同' },
    component: () => import('@/pages/protocol/rongshu/loanForce')
  },
  // 锡商借款合同模版（三方展示）
  {
    path: '/xs-service',
    name: 'xs_service',
    meta: { title: '借款合同' },
    component: () => import('@/pages/protocol/service/xs-service')
  },
  // 易借用户服务协议（易借速贷应用市场审核用，部分渠道使用）
  {
    path: '/app/protocol/register',
    name: 'app_register',
    meta: { title: '易借用户服务协议' },
    component: () => import('@/pages/protocol/app/register')
  },
  // 用户隐私保护政策（易借速贷应用市场审核用，部分渠道使用）
  {
    path: '/app/protocol/private',
    name: 'app_private',
    meta: { title: '用户隐私保护政策' },
    component: () => import('@/pages/protocol/app/private')
  },
  // 用户隐私保护政策（易借速贷应用市场审核用）
  {
    path: '/yjsd/protocol/register',
    name: 'yjsd_register',
    meta: { title: '用户服务协议' },
    component: () => import('@/pages/protocol/app/yjsd_register')
  },
  // 用户隐私保护政策（易借速贷应用市场审核用）
  {
    path: '/yjsd/protocol/private',
    name: 'yjsd_private',
    meta: { title: '用户隐私保护政策' },
    component: () => import('@/pages/protocol/app/yjsd_private')
  },
  // 用户隐私保护政策（易花花应用市场审核用）
  {
    path: '/yhh/protocol/register',
    name: 'yhh_register',
    meta: { title: '用户服务协议' },
    component: () => import('@/pages/protocol/app/yhh-register')
  },
  // 用户隐私保护政策（易花花应用市场审核用）
  {
    path: '/yhh/protocol/private',
    name: 'yhh_private',
    meta: { title: '用户隐私保护政策' },
    component: () => import('@/pages/protocol/app/yhh-private')
  },
  // 征信授信认证（大兴安岭--历史用户）
  {
    path: '/protocol/dxalcredit',
    name: 'protocol_dxalcredit',
    meta: { title: '个人征信信息查询授权书及个人信息使用授权书' },
    component: () => import('@/pages/protocol/dxalcredit')
  },
  // 委托服务协议（大兴安岭历史保险转委托担保时期的协议--历史用户）
  {
    path: '/protocol/serve',
    name: 'serve',
    meta: { title: '委托服务协议' },
    component: () => import('@/pages/protocol/serve')
  },
  // 委托担保协议（大兴安岭--历史用户）
  {
    path: '/protocol/entrustguarantee',
    name: 'protocol_entrustguarantee',
    meta: { title: '委托担保协议' },
    component: () => import('@/pages/protocol/entrustguarantee')
  },
  // 个人信息承诺书-杭金投(更改为后台可配置)
  // {
  //   path: '/protocol/hjt/personInfoPromise',
  //   name: 'protocol_hjt_personInfoPromise',
  //   meta: { title: '《个人信息承诺书》' },
  //   component: () => import('@/pages/protocol/borrow/hjt-userinfo-authorize.vue')
  // },
  {
    path: '/protocol/bindBankcardList',
    name: 'bind_bank_card_protocol_list',
    meta: { title: '《快捷支付及委托扣款协议》' },
    component: () => import('@/pages/protocol/bindBankcardList.vue')
  }
]
